import {
  Box,
  Typography,
  Checkbox,
  FormControlLabel,
  FormGroup,
} from "@mui/material";
import { AVAILABLE_FIELDS } from "../utils/DefaultConfigWitness";

const OrderBadge = ({ position }) => (
  <Box
    sx={{
      width: 20,
      height: 20,
      borderRadius: "4px",
      bgcolor: "#1976d2",
      color: "white",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: "0.75rem",
      fontWeight: "bold",
    }}
  >
    {position}
  </Box>
);

export const FieldsSelector = ({ value, onChange }) => (
  <Box>

    <FormGroup row>
      {AVAILABLE_FIELDS.map(({ key, label }) => {
        const position = value.indexOf(key) + 1;
        return (
          <FormControlLabel
            key={key}
            control={
              <Checkbox
                checked={position > 0}
                onChange={(e) => {
                  const next = e.target.checked
                    ? [...value, key]
                    : value.filter((f) => f !== key);
                  onChange(next);
                }}
                checkedIcon={<OrderBadge position={position} />}
                size="small"
                sx={{ color: "#1976d2" }}
              />
            }
            label={<Typography variant="body2">{label}</Typography>}
          />
        );
      })}
    </FormGroup>
  </Box>
);
